import Cookies from 'js-cookie';
import { action, autorun, computed, observable, toJS } from 'mobx';
import { get } from 'lodash'
import Noty from 'noty';
import { sprintf } from 'sprintf-js';
import api from '../../api';
import { numberFormat } from '../../common';
import { BasketBusiness } from '~/web-frontend-core/store/business/basket';

const mess = {
  'BASKET_ERROR_SYSTEM_3': 'В системе минимум 3 события',
  'SYSTEM_TEMPLATE': '%d по %d (%s %s)',
  "SYSTEM_V1": "вариант",
  "SYSTEM_V4": "варианта",
  "SYSTEM_V5": "вариантов",
}

const MIN_WIDTH = 1500;
export default class BasketStore {
  basketAPI = new api.BasketAPI({ is_mobile: false });
  store = null;
  MAX_COUNT = 29;
  account = null;
  @observable agree_cf = '';
  @observable isLocked = 0;
  @observable betsOrder = [];
  @observable clearBasketAfterBet = false;
  @observable isLoading = true;
  @observable odds = new Map();
  @observable mode = '';
  @observable vip = 0;
  @observable triggerToogle = 0;
  @observable amount = '';
  @observable dict = {
    cmd: {},
    odd: {}
  };
  @observable successBet = {};
  @observable success = {
    status: 0,
    text: 0
  };
  @observable oneClick = {
    st: 0,
    wait: 0,
    amount: 0,
    type: 1,
    showOdd: 0
  };
  @observable amountMax = {
    max: 0,
    minVip: 0,
    html: ''
  };
  @observable fastAmount = {
    // amounts: [100, 500, 1000],
    error: '',
    amount: 0
  };
  @observable possibleWin = 0;
  @observable expressCf = {
    cf: 0,
    html: ''
  };
  @observable type = {
    sys_type: '',
    current: 0
  };
  @observable error = {
    status: 0,
    text: '',
    type: 0
  };
  @observable systemTypeAvailable = [];
  @observable toogleBasket = {
    showArrow: false,
    showBasket: true
  };

  @observable basketData = {}

  @observable maxHeight = 'none';
  @observable live_odds = new Map();
  /** КОСТЫЛЬ: словарь live-ставок, чтобы морозить vip-флажок ставки */
  @computed get no_live_odd() {
    return this.live_odds.size === 0;
  }

  static LOCAL_STORAGE_KEY = 'lineStore_basket';

  constructor(store, accountStore, appStore) {
    this.store = store;
    this.account = accountStore;
    this.appStore = appStore;
    this.onCoefChoose = this.onCoefChoose.bind(this);
    /** Чистим корзину, только если был авторизован */
    accountStore.access && this.clearLocalStorage();
    // if (!this.account.fastAmount) this.fastAmount.amounts = this.account.fastAmount;
    this.init();

    autorun(() => {
      this.setValue('agree_cf', this.account.accountSettings.basketAgreeCf);
      this.setValue('clearBasketAfterBet', this.account.accountSettings.clearBasketAfterBet);
      if (this.account.accountSettings.basketPosition == 'left') {
        this.toogleBasket.showBasket = true;
        this.getMinHeight();
      } else if (this.account.accountSettings.basketPosition == 'right') {
        this.resizeWindow();
        this.getMinHeight();
      }
    });

    this.resizeWindow();
    const isIrm = true
    this.basketBusiness = new BasketBusiness({
      timezone: get(this.appStore, 'timezoneId') || Number(Cookies.get('timezone')) || 3,
      currency: get(this.appStore, 'currency.id') || 2,
      jwt: Cookies.get('jwt'),
      terminal: +Cookies.get('terminal_id'),
      // expressMultiplier: false,
      // expressInsurance: !getConfig('IS_SERVER') ? JSON.parse(localStorage.getItem('insurance_condition') || 'null') || false : false,
      coeffKind: get(this.account, 'settings.coef_id'),
    },
      this.setBasketData.bind(this),
      api.basket,
      'IRM',
      isIrm,
    );

    this.newRestoreFromLocalStorage()

    if (this.account.accountSettings.clearBasketAfterBet) {
      this.newBasketSetIsClearBasketAfterBet()
    }
    this.setAgreeWithCoefChanging(this.account.accountSettings.basketAgreeCf)
    this.newSetIsBetOneClickSum(this.account.accountSettings.oneClickBetAmount || typeof Cookies.get('basket_one_click_amount') !== 'undefined' ? JSON.parse(Cookies.get('basket_one_click_amount')) : 0)
    if(Cookies.get('basket_one_click_toggle')){
      this.newSetIsBetOneClick(JSON.parse(Cookies.get('basket_one_click_toggle')))
    }
    window.addEventListener("resize", () => {
      this.resizeWindow();
    });
  }

  @action setBasketData(data) {
    this.basketData = data;
  }

  @action newAddOdd(oddId, matchId) {
    if(this.basketBusiness.state.isBetOneClick) {
      this.basketBusiness.addOdd(oddId, matchId).then(() => {
        // Логирование совершениня ставки wagerDone - ставка в 1 клик
        const data = this.basketBusiness.doBetRequestData;
        const result = data.result.code;
        const cardId = data.result.card_id;
        const odds = Object.values(data.result.odds);
        const place = 'one_click_bet';

        const type = data.result.type;
        const detailLog = {
          place,
          type
        };

        if (result === 0) {
          detailLog.result = 'success';
          detailLog.cardId = type !== 1 ? cardId : odds.map(odd => odd.card_id);
        } else {
          // Если вернулась ошибка
          detailLog.result = 'error';
          detailLog.error = {
            code: data.result.code,
            message: data.result.text,
          };
        }

        const kafkaData = {
          topic: "wagers",
          action: {
            eventType: "bk",
            eventCode: "wager_done",
            detail: detailLog,
          },
          additional_data: {
            eventSource: 'irm',
            appId: 0,
            appVer: 1,
            login: this.account.login || this.account.AccountPage.data.login || '',
          }
        }

        return api.kafka.kafkaLog(kafkaData);
      });
    } else {
      this.basketBusiness.addOdd(oddId, matchId);
    }

    let oddCash = JSON.parse(localStorage.getItem('BasketOdds') || 'null') || [];
    if (oddCash.length > 29) {
      oddCash.pop()
    }
    oddCash = oddCash.filter(cash => +get(cash, 'matchId') !== +matchId)
    oddCash = oddCash.filter(cash => get(this.basketData, ['odds', cash.oddId, 'cf']))

    localStorage.setItem('BasketOdds', JSON.stringify([...oddCash, { oddId, matchId }]));
  }

  newRestoreFromLocalStorage() {
    const oddCash = JSON.parse(localStorage.getItem('BasketOdds') || 'null') || [];
    this.basketBusiness.addMultiOdds(oddCash.map(cash => get(cash, 'oddId')))
  }

  @action newDeleteOdd(oddId) {
    this.basketBusiness.deleteOdd(oddId);

    let oddCash = JSON.parse(localStorage.getItem('BasketOdds') || 'null') || [];
    oddCash = oddCash.filter(cash => cash.oddId !== oddId)
    oddCash = oddCash.filter(cash => get(this.basketData, ['odds', cash.oddId, 'cf']))

    localStorage.setItem('BasketOdds', JSON.stringify([...oddCash]))

  }

  @action resizeWindow() {
    if (this.account.accountSettings.basketPosition == 'right') {
      if (window.innerWidth >= MIN_WIDTH) {
        this.toogleBasket.showArrow = false;
        this.toogleBasket.showBasket = true;
      } else {
        this.toogleBasket.showArrow = true;
      }
    }
  }

  @action hideBasket() {
    if (this.account.accountSettings.basketPosition == 'right') {
      if (window.innerWidth < MIN_WIDTH) {
        this.toogleBasket.showBasket = false;
      }
    }
  }

  @action setShowBasket() {
    this.toogleBasket.showBasket = !this.toogleBasket.showBasket;
  }

  @action setValue(k, v) {
    this[k] = v;
  }

  @action getMinHeight() {
    if (this.isLoading) return;
    if (this.account.accountSettings.basketPosition == 'right') {
      this.maxHeight = 'none';
    } else {
      const ih = document.querySelector('basket-item') ? document.querySelector('basket-item').offsetHeigth : 80;

      if (this.odds.size > 3) {
        this.maxHeight = 3 * ih;
      } else {
        this.maxHeight = this.odds.size * ih;
      }
    }
  }

  @action checkBasketSettings() {
    const checkCurrency = this.basketBusiness.state.config.currency !== this.appStore.currency.id || 2
    const checkTimeZone = this.basketBusiness.state.config.timezone !== this.appStore.timezoneId || Number(Cookies.get('timezone'))

    if (checkCurrency) {
      this.basketBusiness.state.config.currency = this.appStore.currency.id || 2
    }
    if (checkTimeZone) {
      this.basketBusiness.state.config.timezone = this.appStore.timezoneId || Number(Cookies.get('timezone'))
    }

    if (checkCurrency || checkTimeZone) {
      this.basketBusiness.getOddData()
    }

  }

  @action setAgreeWithCoefChanging(agreeWithOddChanging) {
    this.basketBusiness.setAgreeWithCoefChanging(agreeWithOddChanging)
  }

  @action init() {
    this.mode = this.store.mode;
    this.agree_cf = this.account.accountSettings.basketAgreeCf;
    this.clearBasketAfterBet = this.account.accountSettings.clearBasketAfterBet;
    this.oneClick.amount = this.account.accountSettings.oneClickBetAmount;
    // this.checkBasketSettings()
    this.isLoading = false;
  }


  @action setData(k, v) {
    this[k] = v;
  }


  @action addOdd(odds) {
    if (odds) {
      for (const [key, item] of Object.entries(odds)) {
        if (this.oneClick.st) {
          item['amount'] = this.account.accountSettings.oneClickBetAmount;
        } else {
          if (!this.odds.has(item.gid)) {
            item['amount'] = this.fastAmount.amount;
            this.betsOrder.push(item.gid.toString());
          } else {
            item['amount'] = this.odds.get(item.gid).amount;
          }
        }
        item.c1 = this.dict.cmd[item.c1_id];
        if (item.c2_id) item['c2'] = this.dict.cmd[item.c2_id];
        item['error'] = '';
        item['result'] = '';
        item['status'] = 0; // 0 - add, 1 - success and delete,
        item.name = this.generateBetName(this.dict.odd[item.odd], item.odd, item.d1, item.d2, item.c1, item.c2);
        item.type = item.type || this.mode;
        if (item.type === 'live') {
          this.live_odds.set(`${item.gid}`, item);
        }
        this.odds.set(item.gid, item);
      }
      if (!this.type.current) this.type.current = 1;
      if (!this.triggerToogle && this.odds.size > 1) {
        this.type.current = 2;
      }

      if (this.oneClick.st) this.setBet();

    } else {
      this.setError('Ставка не найдена');
      this.oneClick.wait = 0;
    }
    this.save();
  }

  onCoefChoose(oddID) {
    this.store.sideEffect();
    return this.doBet(oddID);
  }

  @action setBetType(typeId) {
    this.basketBusiness.setBetType(typeId)
  }

  @action newOnOrdinarAmountInput(amount, oddId) {
    this.basketBusiness.onOrdinarAmountInput(amount, oddId)
  }

  @action newSetSystemType(type) {
    this.basketBusiness.setSystemType(type)
  }
  @action newClearBasketAfterBet() {
    this.basketBusiness.clearBasket()
    localStorage.setItem('BasketOdds', JSON.stringify([]))
  }
  @action newBasketSetIsClearBasketAfterBet() {
    this.basketBusiness.setIsClearBasketAfterBet();
  }

  @action newBasketDoBetRequest() {
    this.basketBusiness.doBetRequest().then(() => {
      // Логирование совершениня ставки wagerDone
      const data = this.basketBusiness.doBetRequestData;
      const result = data.result.code;
      const cardId = data.result.card_id;
      const odds = Object.values(data.result.odds);
      const place = 'fromBasket';

      const type = data.result.type;
      const detailLog = {
        place,
        type
      };

      if (result === 0) {
        detailLog.result = 'success';
        detailLog.cardId = type !== 1 ? cardId : odds.map(odd => odd.card_id);
      } else {
        // Если вернулась ошибка
        detailLog.result = 'error';
        detailLog.error = {
          code: data.result.code,
          message: data.result.text,
        };
      }

      const kafkaData = {
        topic: "wagers",
        action: {
          eventType: "bk",
          eventCode: "wager_done",
          detail: detailLog,
        },
        additional_data: {
          eventSource: 'irm',
          appId: 0,
          appVer: 1,
          login: this.account.login || this.account.AccountPage.data.login || '',
        }
      }

      return api.kafka.kafkaLog(kafkaData);
    })

    if (this.basketData.isRequestSuccess && this.basketData.isClearBasketAfterBet) {
      localStorage.setItem('BasketOdds', JSON.stringify([]))
    }
  }

  @action newSetIsVipBet(isVipBet) {
    this.basketBusiness.setIsVipBet(isVipBet)
  }

  @action newSetIsBetOneClick(isOneClick) {
    Cookies.set('basket_one_click_toggle', isOneClick);
    this.basketBusiness.setIsBetOneClick(isOneClick)
  }

  @action newSetIsBetOneClickSum(amount) {
    Cookies.set('basket_one_click_amount', amount);
    this.basketBusiness.setIsBetOneClickSum(amount)
  }

  @action newOnExpressOrSystemAmountInput(amount) {
    this.basketBusiness.onExpressOrSystemAmountInput(amount)
  }

  @action newSetError(errorText) {
    this.basketBusiness.setGlobalError(errorText)
  }

  @action applyOneClickAmount() {
    if (this.basketData.oneClickBetAmount) {
      if (!this.account.access) {
        this.account.showLoginForm = true;
        return false;
      }
      this.oneClick.wait = 1;
      api.basket.setOneClickAmount(this.basketData.oneClickBetAmount).then(
        action((data) => {
          if (data.code == "OK") {
            this.newSetError('Изменения сохранены');
            this.account.toggleAccountSettings('oneClickBetAmount', this.basketData.oneClickBetAmount);
          } else {
            this.newSetError(data.text);
          }
        }))
        .catch(action(err => {
          this.newSetError('Ошибка сервера');
        }))
        .finally(action(() => {
          this.oneClick.wait = 0;
          this.basketBusiness.notify()
        }));
    } else {
      this.newSetError('Укажите сумму');
      this.basketBusiness.notify()
    }
  }

}


// WEBPACK FOOTER //
// ./src/stores/lineStore/basket.js